
<template>
  <vs-popup
    class="holamundo"
    popup-class="w-9/12"
    title="ویرایش"
    :active.sync="popupActive"
  >
    <template v-if="createEditMode == CreateEditMode.Create">
      <form id="formStepStart" data-vv-scope="step-start">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              v-validate="{ required: true, regex: '^([+]98|0)?9[0-9]{9}$' }"
              inputmode="numeric"
              label="تلفن همراه"
              name="mobile"
              v-model="mobile"
              class="w-full"
            />
            <span class="text-danger text-sm">{{
              errors.first("step-start.mobile")
            }}</span>
          </div>
          <div class="vx-col w-full">
            <vs-button
              @click="newRequest"
              class="my-3"
              color="success"
              type="filled"
              icon-pack="feather"
              icon="icon-file-plus"
              >ایجاد درخواست پذیرندگی</vs-button
            >
          </div>
        </div>
      </form>
    </template>
    <vs-tabs v-else>
      <!-- tab 1 content -->
      <vs-tab label="اطلاعات شخصی">
        <edit-personal-data
          ref="editPersonalData1"
          :draftRequest="draftRequest"
        />
      </vs-tab>

      <!-- tab 2 content -->
      <vs-tab label="اطلاعات شخص حقوقی">
        <edit-legal-data ref="editLegalData1" :draftRequest="draftRequest" />
      </vs-tab>

      <!-- tab 3 content -->
      <vs-tab
        label="اطلاعات ترمینال"
        v-if="[5, 13].includes(draftRequest.step)"
        activeTabIndex
      >
        <edit-terminal-data
          ref="editTerminallData1"
          :draftRequest="draftRequest"
        />
      </vs-tab>

      <!-- tab 2 content -->
      <vs-tab label="اطلاعات کسب و کار">
        <edit-shop-data ref="editShopData1" :draftRequest="draftRequest" />
      </vs-tab>

      <!-- tab 5 content -->
      <vs-tab label="مدارک">
        <attachments :id="draftRequest.id" />
      </vs-tab>
    </vs-tabs>
  </vs-popup>
</template>
<style>
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
[dir="rtl"] .ltr-input * {
  direction: ltr;
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
<script>
const dict = {
  custom: {
    mobile: {
      required: "موبایل را وارد کنید",
      regex: "شماره همراه صحیح نمی‌باشد",
    },
  },
};
import Vue from "vue";
Validator.localize("en", dict);

import Lightbox from "vue-easy-lightbox";
Vue.use(Lightbox);

import { Validator } from "vee-validate";
import { CreateEditMode } from "@/enums.js";
import EditPersonalData from "./EditPersonalData.vue";
import EditLegalData from "./EditLegalData.vue";
import EditTerminalData from "./EditTerminalData.vue";
import EditShopData from "./EditShopData.vue";
import Attachments from "./Attachments.vue";
export default {
  name: "create-or-edit-draft-merchants",
  props: {},
  components: {
    EditPersonalData,
    EditLegalData,
    EditTerminalData,
    EditShopData,
    Attachments,
  },
  data() {
    return {
      popupActive: false,
      CreateEditMode,
      createEditMode: CreateEditMode.Create,
      draftRequest: {
        id: 0,
        draftMerchant: {},
        pspRequestShopAcceptors: [{ shop: {} }],
      },
      mobile: "",
    };
  },
  computed: {
    birthCrtfctSeriesLetterList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.BirthCrtfctSeriesLetter)) {
        ms.push({ value: key, label: value.text });
      }
      return ms;
    },
    editForbiden() {
      return [13, 5].includes(this.draftRequest.step);
    },
  },
  watch: {},
  methods: {
    newRequest() {
      let loading = this.$vs.loading();
      let payload = {
        Mobile: this.mobile,
      };
      this.$http
        .post("/api/services/app/Draft/Create", payload)
        .then((response) => {
          if (response.data.result) {
            this.createEditMode = CreateEditMode.Edit;
            this.draftRequest.id = response.data.result;
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "درخواست با موفقیت ایجاد شد",
            });
            this.$vs.loading.close();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    show(id) {
      this.defaultIban = "";
      if (id) {
        this.createEditMode = CreateEditMode.Edit;
        this.getMerhant(id);
      } else {
        this.popupActive = true;
        this.createEditMode = CreateEditMode.Create;
        let d = {
          draftMerchant: {},
          pspRequestShopAcceptors: [{ shop: {} }],
        };
        d.pspRequestShopAcceptors[0].shop.businessType =
          BusinessType.Combined.value;
        this.draftRequest = {
          id: 0,
          draftMerchant: {},
          pspRequestShopAcceptors: [{ shop: {} }],
        };
        this.draftRequest = d;
      }
    },
    async getMerhant(id) {
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          id: id,
        },
      };
      this.$http
        .get("/api/services/app/Draft/Get", payload)
        .then(async (response) => {
          this.popupActive = true;
          this.draftRequest = response.data.result;
          this.$refs.formWizard.activateAll();
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    // async existMobileNo(mobile) {
    //   return new Promise((resolve, reject) => {
    //     let loading = this.$vs.loading();
    //     //this.$vs.loading()
    //     let payload = {
    //       mobile: mobile,
    //     };
    //     this.$http
    //       .post(`/api/services/app/merchants/ExistMerchant?mobile=${mobile}`)
    //       .then((response) => {
    //         this.$vs.loading.close();
    //         if (response.data.result) {
    //           this.$vs.notify({
    //             time: 5000,
    //             color: "danger",
    //             title: "موبایل تکراری!",
    //             text: "این موبایل قبلا ثبت شده است",
    //           });
    //           resolve(true);
    //         } else resolve(false);
    //       }) //end success
    //       .catch((error) => {
    //         this.$vs.loading.close();
    //         reject("error");
    //       });
    //   });
    // },
  },
  mounted() {},
};
</script>